export default class Api {
  baseUrl = process.env.REACT_APP_API_URI || 'https://tmapi.vercel.app';
}
